import { useState } from 'preact/hooks';
import type { ClientView } from '@gazette/shared';
import { t, tn } from '../../i18n/index.ts';
import { actions, isHost } from '../../net/client.ts';
import { ErrorNotice, GameHeader } from '../components/Chrome.tsx';
import { GazetteSheet } from '../components/GazetteSheet.tsx';
import { Icon } from '../components/Icon.tsx';

export function Publication({ current }: { current: ClientView }) {
  const [reading, setReading] = useState(false);
  const gazette = current.gazette!;
  return (
    <>
      <GameHeader />
      <section class={`sheet ${reading ? 'sheet--full' : 'sheet--bar'}`} data-occlude aria-labelledby="edition-title">
        <div class="edition">
          <h2 id="edition-title" class="edition__title">
            {t('pub.title')}
          </h2>
          <p class="edition__count">
            {t('gz.edition', { n: gazette.edition })} · {tn('pub.count', gazette.articles.length)}
          </p>
          <div class="edition__actions">
            <button type="button" class="btn btn--secondary" aria-expanded={reading} onClick={() => setReading(!reading)}>
              {reading ? t('pub.close') : t('pub.read')}
            </button>
            {isHost.value ? (
              <button type="button" class="btn btn--primary" onClick={() => void actions.advance()}>
                {t('pub.start')}
                <Icon name="next" size={20} />
              </button>
            ) : (
              <p class="hint">{t('pub.waitHost')}</p>
            )}
          </div>
          <ErrorNotice />
        </div>
        {reading && <GazetteSheet current={current} revealed={false} />}
      </section>
    </>
  );
}
